var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetElasticSuggestions, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: "../engine/essuggest",
            data: {
                query: envelope.message.data.query,
                fuzziness: envelope.message.data.fuzziness,
                resultType: envelope.message.data.resultType,
                since: envelope.message.data.since,
                size: envelope.message.data.size
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetElasticSuggestionsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetElasticSuggestionsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetFiltersElasticResults, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: "../engine/esqueryfiltervalues",
            data: {
                type: "products",
                query: envelope.message.data.searchTerm,
                path: envelope.message.data.path ? envelope.message.data.path : "/",
                filters: envelope.message.data.filters,
                baseuri: envelope.message.data.baseuri
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetFiltersElasticResultsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetFiltersElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetCategoryElasticResults, Vendd.ElasticSearch, function (envelope) {

		var options = {
			url: "../engine/esqueryindex",
			data: {
				type: "categories",
				query: envelope.message.data.searchTerm,
				pagefrom: envelope.message.data.pageFrom,
				pagesize: envelope.message.data.pageSize,
				path: "?hidefromsearch=1"
			},
            onSuccess: onSuccess,
            onFailure: onFailure
		};

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetCategoryElasticResultsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetCategoryElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetProductElasticResults, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: envelope.message.data.query ? "../engine/esqueryindex" + envelope.message.data.query : "../engine/esqueryindex",
			data: {
				type: "products",
				query: envelope.message.data.searchTerm,
				pagefrom: envelope.message.data.pageFrom,
				pagesize: envelope.message.data.pageSize,
				path: envelope.message.data.path ? envelope.message.data.path : "?hidefromsearch=1"
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetProductElasticResultsSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetProductElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetArticleElasticResults, Vendd.ElasticSearch, function (envelope) {

        var options = {
            url: "../engine/esqueryindex",
            data: {
                type: "articles",
                query: envelope.message.data.searchTerm,
                pagefrom: envelope.message.data.pageFrom,
                pagesize: envelope.message.data.pageSize,
                path: "?hidefromsearch=1"
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetArticleElasticResultsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.ElasticSearch, new Vendd.ElasticSearch.Messages.GetArticleElasticResultsFailed(response));
        }

        Vendd.Service.call(options);
    });
    return Vendd;

})(Vendd || {});